<div class="h-full overflow-hidden">
  <p-table
    [value]="ssbKonfigService.output()"
    stripedRows
    [showGridlines]="true"
    [loading]="ssbKonfigService.data.isLoading()"
    [scrollable]="true"
    scrollHeight="flex"
    class="p-datatable-sm lp-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Nøgle</th>
        <th>Værdi</th>
        <th>Type</th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="ssbKonfigService.output()" pTemplate="body" let-item>
      <tr>
        <td>{{ item.noegle }}</td>
        <td>{{ item.vaerdi }}</td>
        <td>{{ item.type }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
